import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=158656f8&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=js&"
export * from "./LandingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158656f8",
  null
  
)

export default component.exports